import React, {Component} from "react";
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {requestServiceLevelData} from "../../actions/serviceLevelDataActions";
import Select from "../Select/Select";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CalendarInput from './../CalendarInput/CalendarInput';
import Lookup from '../Lookup/Lookup';
import {REQUEST_NON_REV_AND_REV_FACILITIES_DATA} from "../../actions/nonRevAndRevFacilitiesActions";
import {requestScheduleData} from "../../actions/schedulesDataActions";
import queryString from "query-string";
import moment from "moment";
import Skeleton from "../Skeleton/Skeleton";
import ContentPanel from '../ContentPanel/ContentPanel';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from "@material-ui/core/Modal/Modal";

class FlightScheduleSearch extends Component {

  constructor(props) {
    super(props);

    this.state = {
      origin: null,
      destination: null,
      serviceLevel: null,
      date: moment(),
      errorObject: {},
      departOrArrive: 'depart',
      infoText: '',
      time: '12:00 AM',
      timeOptions: [
        {
          name: "Please select...", value: "Please select..."
        },
        {
          name: '12:00 AM', value: "00:00:00"
        },
        {
          name: '1:00 AM', value: "01:00:00"
        },
        {
          name: '2:00 AM', value: "02:00:00"
        },
        {
          name: '3:00 AM', value: "03:00:00"
        },
        {
          name: '4:00 AM', value: "04:00:00"
        },
        {
          name: '5:00 AM', value: "05:00:00"
        },
        {
          name: '6:00 AM', value: "06:00:00"
        },
        {
          name: '7:00 AM', value: "07:00:00"
        },
        {
          name: '8:00 AM', value: "08:00:00"
        },
        {
          name: '9:00 AM', value: "09:00:00"
        },
        {
          name: '10:00 AM', value: "10:00:00"
        },
        {
          name: '11:00 AM', value: "11:00:00"
        },
        {
          name: '12:00 PM', value: "12:00:00"
        },
        {
          name: '1:00 PM', value: "13:00:00"
        },
        {
          name: '2:00 PM', value: "14:00:00"
        },
        {
          name: '3:00 PM', value: "15:00:00"
        },
        {
          name: '4:00 PM', value: "16:00:00"
        },
        {
          name: '5:00 PM', value: "17:00:00"
        },
        {
          name: '6:00 PM', value: "18:00:00"
        },
        {
          name: '7:00 PM', value: "19:00:00"
        },
        {
          name: '8:00 PM', value: "20:00:00"
        },
        {
          name: '9:00 PM', value: "21:00:00"
        },
        {
          name: '10:00 PM', value: "22:00:00"
        },
        {
          name: '11:00 PM', value: "23:00:00"
        }
      ]
    };

    let params = queryString.parse(this.props.location.search);

    this.state = {
      ...this.state,
      origin: params.origin,
      destination: params.destination,
      serviceLevel: params.serviceLevel,
      date: params.date,
      departOrArrive: params.departOrArrive || "depart",
      time: params.time || "Please select...",
      errorObject: {
        serviceLevelError: false,
        timeError: false,
        dateError: false,
        originError: false,
        destinationError: false
      },
      validationError: false
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSubmit = this._handleSubmit.bind(this);
  };

  componentDidMount() {
    this.props.requestServiceLevelData();
    if (!this.props.nonRevAndRevFacilities) {
      this.props.getNonRevAndRevFacilities();
    }
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  };


  getQueryStringParams = () => {

    let params = {
      origin: this.state.origin,
      destination: this.state.destination,
      serviceLevel: this.state.serviceLevel,
      departOrArrive: this.state.departOrArrive,
      date: this.state.date,
      time: this.state.time === "Please select..." ? "00:00:00" : this.state.time
    };

    return params;

  };

  _handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      validationError: false
    });

    this.validateInput("origin", this.state.origin);
    this.validateInput("destination", this.state.destination);
    this.validateInput("date", this.state.date);
    this.validateInput("time", this.state.time);
    this.validateInput("serviceLevel", this.state.serviceLevel);

    if (this.isValid()) {
      let params = this.getQueryStringParams();
      params.nonRevAndRevFacilities = this.props.nonRevAndRevFacilities;

      this.props.getScheduleData(params);
    } else {
      this.setState({
        validationError: true
      });
    }
  };

  getFacilitiesList = () => {
    return this.props.nonRevAndRevFacilities.map((facility) => {
      return {
        name: `${facility.commonAirportName}, ${facility.facilityInfo.location.stateName} - ${facility.airportCodeIATA}`,
        airportCode: facility.airportCodeIATA,
        airportName: facility.commonAirportName,
        value: facility.airportCodeIATA
      }
    });
  };

  selectedOriginAirportCodeHandler = (airportCode) => {
    this.setState({
      origin: airportCode
    })
  };

  selectedDestinationAirportCodeHandler = (airportCode) => {
    this.setState({
      destination: airportCode
    })
  };

  getErrorClass = () => {
    if (this.props.error) {
      return "schedules-search-error-wrapper mtl alert alert-danger";
    } else {
      return "schedules-search-error-wrapper-hide";
    }
  };

  getNoResultsClass = () => {
    if (this.props.noResults) {
      return "schedules-search-error-wrapper mtl alert alert-danger";
    } else {
      return "schedules-search-error-wrapper-hide";
    }
  };

  getValidationErrorClass = () => {
    if (this.state.validationError) {
      return "schedules-search-error-wrapper mtl alert alert-danger";
    } else {
      return "schedules-search-error-wrapper-hide";
    }
  };

  isValid() {

    if (!this.state.serviceLevel || this.state.errorObject.serviceLevelError || this.state.serviceLevel === "Please select...") {
      return false;
    }

    if (!this.state.origin || this.state.errorObject.originError) {
      return false;
    }

    if (!this.state.destination || this.state.errorObject.destinationError) {
      return false;
    }

    if (!this.state.date || this.state.errorObject.dateError) {
      return false;
    }

    if (!this.state.time || this.state.errorObject.timeError) {
      return false;
    }

    return true;
  }

  validateInput = (name, value) => {

    let errorObject = {};

    errorObject[name + "Error"] = (value === null) || (typeof value === "undefined");

    if (name === "serviceLevel") {
      errorObject.serviceLevelError = value === "Please select...";
    }

    if (name === "time") {
        errorObject.timeError = !this.state.timeOptions.some(time => time.value === value);
    }

    if (name === "origin") {
      errorObject.originError = "" === value;
    }

    if (name === "destination") {
      errorObject.destinationError = value === "";
    }

    this.setState({
      ...this.state.errorObject,
      errorObject: errorObject
    });

  };

  handleDateChange = (date) => {

    let dateStr = date.format("YYYY-MM-DD")
    this.setState({date: dateStr});
    this.validateInput("date", dateStr);
  };

  handleDateBlur = (date) => {
    this.validateInput("date", date);
  };

  handleBlur = (e) => {
    this.validateInput(e.target.name, e.target.value);
  };

  getPageView() {
    const selectedOriginSuggestion = this.getFacilitiesList().filter((facility) => {
      return facility.airportCode === this.state.origin;
    });
    const selectedDestinationSuggestion = this.getFacilitiesList().filter((facility) => {
      return facility.airportCode === this.state.destination;
    });
    const dateObject = this.state.date ? moment(this.state.date) : null;

    return (
      <div>
        <div className={this.getErrorClass()}>This feature is currently not available. Please try again. If the error
          continues, please call our Customer CARE Center at (800) 533-1222.
        </div>
        <div className={this.getNoResultsClass()}>Routes are not available for the selected criteria. Please check the
          origin, destination, and/or service level, and try again.
        </div>
        <div className={this.getValidationErrorClass()}>Please enter missing required fields</div>
        <p className="mtl">{this.props.infoText}</p>
        <div className="schedules-search-required mtm">
          <span className="tracking-advanced-search-superscript-required-header">*</span>
          <span> Required </span>
        </div>
        <form onSubmit={this.handleSubmit} noValidate>
          <div className="fg mtm">
            <div
              className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
              <label className="input-label" id="departure">Departure city or airport code<span
                className="schedules-search-superscript">*</span></label>
              <Lookup
                className={this.state.errorObject.originError ? "schedule-search-input error" : "schedule-search-input error"}
                name="origin"
                dataList={this.getFacilitiesList()}
                onChange={this.selectedOriginAirportCodeHandler}
                onBlur={this.handleBlur}
                selectedSuggestion={selectedOriginSuggestion[0]}
              />
            </div>
            <div
              className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
              <label className="input-label" id="departure">Arrival city or airport code<span
                className="schedules-search-superscript">*</span></label>
              <Lookup
                className={this.state.errorObject.destinationError ? 'tracking-advanced-search-input' : ""}
                name="destination"
                dataList={this.getFacilitiesList()}
                onChange={this.selectedDestinationAirportCodeHandler}
                onBlur={this.handleBlur}
                selectedSuggestion={selectedDestinationSuggestion[0]}
              />
            </div>
            <div
              className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
              <Select
                selected={this.props.serviceLevelData.find(item => {
                  return item.value === this.state.serviceLevel
                })}
                hasPleaseSelectOption={true}
                name="serviceLevel"
                title="Products"
                resetOnPropsUpdate={true}
                options={
                  this.props.serviceLevelData.map((service) => {
                      return {
                        name: service.name,
                        value: service.value
                      }
                    }
                  )
                }
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                desktopWidth={'100%'}
                tabletWidth={'100%'}
                mobileWidth={'100%'}
              />
            </div>
          </div>
          <div className="flex mvs">
            <div className="radio-container radio-container--spaced">
              <input onChange={this.handleChange} onBlur={this.handleBlur}
                     checked={this.state.departOrArrive === 'depart'}
                     name="departOrArrive" id="radio-departure" type="radio" value="depart" className="radio"/>
              <label className="radio-label" htmlFor="radio-departure">Departure city drop-off time</label>
            </div>
            <div className="radio-container radio-container--spaced">
              <input onChange={this.handleChange} onBlur={this.handleBlur}
                     checked={this.state.departOrArrive === 'arrive'}
                     name="departOrArrive" id="radio-arrival" type="radio" value="arrive" className="radio"/>
              <label className="radio-label" htmlFor="radio-arrival">Arrival city pick-up time</label>
            </div>
          </div>
          <div className="fg mtm">
            <div
              className="fg__col-lg-3 fg__col-md-6 fg__col-sm-12">
              <label className="input-label mb8" id="departure">Departure date<span
                className="schedules-search-superscript">*</span></label>
              <DatePicker
                customInput={<CalendarInput
                  isValid={true}/>
              }
                minDate={moment()}
                maxDate={moment().add(10, "days")}
                selected={dateObject}
                onChange={this.handleDateChange}
              />

            </div>
            <div
              className="fg__col-lg-3 fg__col-md-6 fg__col-sm-12">
              <Select
                selected={this.state.timeOptions.find(item => {
                    return item.value === this.state.time
                })}
                resetOnPropsUpdate={true}
                name="time"
                title="Time"
                options={this.state.timeOptions}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                desktopWidth={'100%'}
                tabletWidth={'100%'}
                mobileWidth={'100%'}
              />
            </div>
          </div>
          <button type="submit" className="cta-button mtl" disabled={this.props.isFetching}>Search</button>
        </form>
        <Modal open={this.props.isFetching}
               disableBackdropClick={true}
               disableAutoFocus={true}>
            <CircularProgress className={'schedules-search-circular-progress'}/>
        </Modal>
        <ContentPanel
          skeleton={<Skeleton type="CONTENT_PANEL"/>}
          errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
          templateUrl="./content/ship/page-components/text-block/legal.html"
        />
      </div>
    );
  };

  getErrorMessage = () => {
    if (this.props.serviceError) {
      return 'This feature is currently not available. Please try again. If the error continues, please call our Customer CARE Center at 1 (800) 533-1222.';
    }
  };

  render() {
    if (this.props.serviceError) {
      return (
        <div className="tracking-advanced-search-error-wrapper alert alert-danger">
          {this.getErrorMessage()}
        </div>
      );
    }
    return this.props.nonRevAndRevFacilities ? this.getPageView() : <Skeleton type="SHORT_CONTENT"/>;
  }
}

FlightScheduleSearch.propTypes = {
  requestServiceLevelData: PropTypes.func.isRequired,
  serviceLevelData: PropTypes.array.isRequired,
  infoText: PropTypes.string,
  error: PropTypes.string,
  date: PropTypes.string,
  departOrArrive: PropTypes.string,
  destination: PropTypes.string,
  origin: PropTypes.string,
  serviceLevel: PropTypes.string,
  isFetching: PropTypes.bool
};

FlightScheduleSearch.defaultProps = {
    isFetching: false
};

const mapStateToProps = state => ({
  nonRevAndRevFacilities: state.nonRevAndRevFacilitiesData.nonRevAndRevFacilities,
  serviceLevelData: state.serviceLevelData.items,
  error: state.scheduleData.error,
  noResults: state.scheduleData.noResults,
  serviceError: state.nonRevAndRevFacilitiesData.error,
  isFetching: state.scheduleData.isFetching
});

const mapDispatchToProps = dispatch => ({
  getNonRevAndRevFacilities: () => dispatch({type: REQUEST_NON_REV_AND_REV_FACILITIES_DATA}),
  requestServiceLevelData: () => {
    dispatch(requestServiceLevelData())
  },
  getScheduleData: data => {
    dispatch(requestScheduleData(data))
  }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FlightScheduleSearch));



// WEBPACK FOOTER //
// ./src/components/FlightScheduleSearch/FlightScheduleSearch.js